import { TemplateAllocation } from 'data/templates/projects';

export const totalMinutesFromAllocations = (
  allocations: TemplateAllocation[],
): number =>
  allocations.reduce(
    (total, { minutes, duration }) => total + minutes * duration,
    0,
  );
